<template>
  <div class="file-button">
    <label for="logo" class="waves-effect btn-large">{{ label }}</label>
    <input
      type="file"
      id="logo"
      accept="image/png, image/jpeg"
      @change="changeFile"
    />
    <span>{{ error || errorInternal }}</span>
  </div>
</template>

<script>
import fileToBase64 from "@/services/mixins/fileToBase64";

export default {
  name: "InputFile",
  mixins: [fileToBase64],
  data: () => ({
    errorInternal: ""
  }),
  props: {
    error: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Upload"
    }
  },
  methods: {
    async changeFile(e) {
      const file = e.target.files[0];
      if (file) {
        if (file.size <= 5e6) {
          if (
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg"
          ) {
            const base64 = await this.toBase64(e.target.files[0]);
            this.$emit("change", base64);
            this.errorInternal = "";
          } else {
            this.errorInternal = "Arquivos permitidos: jpg, jpeg e png";
          }
        } else {
          this.errorInternal = "Arquivo muito grande, max: 5 Mb";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.file-button {
  min-width: 200px;
  @media #{$small-and-down} {
    width: 100%;
  }
  margin-bottom: 32px;
  input {
    opacity: 0;
    position: absolute;
    z-index: -1;
    width: 1px;
  }
  span {
    position: relative;
    min-height: 18px;
    display: block;
    font-size: 12px;
    color: #f44336;
    margin-top: 8px;
    text-align: center;
  }
}
</style>
